const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511 511.99938",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m445.316406 248.242188c-2.714844-4.496094-7.585937-7.242188-12.835937-7.242188-44.296875 0-84.851563 22.769531-107.945313 60h-177.898437c-20.03125 0-38.867188 7.800781-53.03125 21.96875l-88.714844 88.710938c-5.851563 5.855468-5.855469 15.355468 0 21.214843 36.429687 36.425781 74.660156 74.375 75.042969 74.75 5.855468 5.816407 15.304687 5.800781 21.148437-.011719l56.894531-56.632812h125.660157c39.191406 0 74.832031-21.558594 93-56.261719.457031-.871093 45.890625-87.574219 69.117187-131.757812 2.445313-4.652344 2.28125-10.238281-.4375-14.738281zm-95.253906 132.578124c-12.976562 24.785157-38.429688 40.179688-66.425781 40.179688h-131.851563c-3.96875 0-7.773437 1.570312-10.582031 4.367188l-50.714844 50.480468c-11.949219-11.875-32.511719-32.332031-53.773437-53.566406l78.101562-78.101562c8.5-8.5 19.800782-13.179688 31.820313-13.179688h161.796875l-11.511719 21.964844c-2.597656 4.957031-7.6875 8.035156-13.285156 8.035156h-101.851563c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h101.851563c16.789062 0 32.0625-9.238281 39.859375-24.109375.011718-.027344 23.152344-44.179687 23.152344-44.179687 12.5625-23.765626 34-40.820313 59.042968-47.972657-23.933594 45.59375-55.246094 105.355469-55.628906 106.082031zm0 0",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m136.785156 271h180c8.28125 0 15-6.714844 15-15v-181c0-8.285156-6.71875-15-15-15h-45v-15c0-24.8125-20.1875-45-45-45s-45 20.1875-45 45v15h-45c-8.285156 0-15 6.714844-15 15v181c0 8.285156 6.714844 15 15 15zm75-226c0-8.269531 6.726563-15 15-15 8.269532 0 15 6.730469 15 15v15h-30zm-60 45h30v15c0 8.285156 6.714844 15 15 15 8.28125 0 15-6.714844 15-15v-15h30v15c0 8.285156 6.714844 15 15 15 8.28125 0 15-6.714844 15-15v-15h30v151h-150zm0 0",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.249a96d4752a7ba00e01ae6fd8ec3697.svg";
export { ForwardRef as ReactComponent };